import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Error } from '../../styles';
import { SubmitInput, Success, Select } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';
const CreateCode: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleYesClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    const target = e.target as typeof e.target & {
      extensionType: { value: string };
      codes: { value: number };
    };
    
    const extensionType = target.extensionType.value;
    const codes = target.codes.value;
    
    if (!codes) {
      alert('Invalid input for codes generator');
      return;
    }

    if (!extensionType) {
      alert('Please select an extension type');
      return;
    }

    setIsLoading(true);
    
    try {
      const result = await callFunction('referralsAndPromoCodes/generateAndSaveGuiderCodes', {
        extensionType,
        numOfCodes: Number(codes) > 0 ? Number(codes) : undefined
      });
      
      console.log('Generated codes:', result);
      setSuccess(`Successfully created code/s:\n${JSON.stringify(result, null, 2)}`);
    } catch (error: any) {
      console.error('Failed to generate codes:', error);
      setError(error?.message || error?.error || 'Failed to generate codes');
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleNoClick = () => {};

  const handleAlert = (e: React.SyntheticEvent) => {
    const confirmed = window.confirm('Are you sure you want to create codes?');
    if (confirmed) {
      handleYesClick(e);
    } else {
      handleNoClick();
    }
  };
  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleAlert}>
        <Select id="cars" name="extensionType">
        <option value="WEEKLY">Weekly</option>
        <option value="MONTHLY">Monthly</option>
        <option value="ANNUALLY">Annually</option>
      </Select>
      <Input placeholder="Number of codes" type="number" name="codes" />
      <SubmitInput type="submit" value={isLoading ? "Generating..." : "Generate"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
      </Form>
    </>
  );
};

export { CreateCode };
